<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <!--    main form page-->
    <div v-show="main" class="add-pog-layout">
      <v-layout
        row
        wrap
        fill-height
        align-space-around
        class="container-layout"
      >
        <v-flex sm12 md6 lg3>
          <v-card class="form-pad card-pad card-layout" flat hover>
            <!--        name-->
            <v-text-field
              v-model="pog.name"
              :rules="[(v) => !!v || 'A name is required']"
              label="Name"
              required
            ></v-text-field>
            <!--      type-->
            <v-select
              v-model="pog.type"
              :items="types"
              :rules="[(v) => !!v || 'A type is required']"
              label="Type of Project"
              required
            ></v-select>
            <!--      responsible-->
            <!-- <v-select
              v-model="pog.responsible"
              :items="responsibleTypes"
              :rules="[(v) => !!v || 'A Land Ownership Type is required']"
              label="Land Ownership Type"
              required
            ></v-select> -->
          </v-card>
        </v-flex>

        <v-flex sm12 md6 lg3>
          <v-slide-x-reverse-transition>
            <v-card
              class="form-pad card-pad card-layout"
              v-show="next[0]"
              flat
              hover
            >
              <!--              Main Activities-->
              <v-combobox
                v-model="pog.activity"
                :items="activities"
                small-chips
                label="Choose or type one or more activities"
                hint="Start typing"
                persistent-hint
                multiple
                clearable
                required
                :rules="[(v) => v.length > 0 || 'At least one is required']"
              >
                <template v-slot:prepend-item>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        Press <kbd>tab</kbd> or <kbd>enter</kbd> to submit what
                        you've typed
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-combobox>

              <!--              Partners-->
              <v-combobox
                v-model="pog.partners"
                hint="Start typing"
                label="Project Partners"
                multiple
                persistent-hint
                small-chips
              >
                <template v-slot:no-data>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        Press <kbd>tab</kbd> or <kbd>enter</kbd> to submit what
                        you've typed
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-combobox>

              <!-- status -->
              <v-radio-group
                label="Project may be viewed by:"
                v-model="pog.perms"
              >
                <v-radio label="Only you and Admins" value="user"></v-radio>
                <v-radio
                  label="Other authenticated users"
                  value="auth"
                ></v-radio>
                <v-radio
                  label="The public (with limited zoom)"
                  value="public"
                ></v-radio>
              </v-radio-group>
            </v-card>
          </v-slide-x-reverse-transition>
        </v-flex>

        <v-flex sm12 md6 lg3>
          <v-slide-x-reverse-transition>
            <v-card
              class="form-pad card-pad card-layout"
              v-show="next[1]"
              flat
              hover
            >
              <v-layout row wrap>
                <v-flex>
                  <!--          Coordinates-->
                  <v-btn flat @click="collectLocation()">
                    <v-icon>{{
                      pog.coordinates.lng
                        ? "check_circle_outline"
                        : "edit_location"
                    }}</v-icon>
                    <div class="font-weight-light">
                      &nbsp;
                      {{
                        pog.coordinates.lat && pog.coordinates.lng
                          ? `${Math.round(pog.coordinates.lat * 1000) /
                              1000}, ${Math.round(pog.coordinates.lng * 1000) /
                              1000}`
                          : "Location"
                      }}
                    </div>
                  </v-btn>
                  <!--      Contact-->
                  <v-btn
                    flat
                    @click="
                      changeContact = true;
                      $emit('toggle-close');
                      main = false;
                    "
                  >
                    <v-icon>{{
                      pog.contact.email ? "check_circle_outline" : "edit"
                    }}</v-icon>
                    <div class="font-weight-light">
                      &nbsp;
                      {{
                        pog.contact.email
                          ? pog.contact.email
                          : "Manager Contact"
                      }}
                    </div>
                  </v-btn>
                  <!--      Start Time-->
                  <v-btn
                    flat
                    @click="
                      main = false;
                      startTimePicker = true;
                      $emit('toggle-close');
                    "
                  >
                    <v-icon>{{
                      pog.start ? "check_circle_outline" : "date_range"
                    }}</v-icon>
                    <div class="font-weight-light">
                      &nbsp; {{ pog.start ? pog.start : "Start Date" }}
                    </div>
                  </v-btn>
                </v-flex>

                <!--                  size-->
                <v-flex sm6>
                  <v-text-field v-model="pog.size" label="Area (size)" number>
                  </v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-select
                    v-model="pog.sizeType"
                    :items="sizeTypes"
                  ></v-select>
                </v-flex>

                <v-flex sm6>
                  <!--          Duration-->
                  <v-text-field
                    v-model="pog.timeline"
                    :mask="'###'"
                    label="Expected Timeline"
                  ></v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-select
                    v-model="pog.timelineType"
                    :items="timelines"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card>
          </v-slide-x-reverse-transition>
        </v-flex>

        <v-flex sm12 md6 lg3>
          <v-slide-x-reverse-transition>
            <v-card
              class="form-pad card-pad card-layout text-lg-center"
              v-show="next[2]"
              flat
              hover
            >
              <!--      Comments (i.e. milestones)-->
              <h4 class="font-weight-light text-uppercase">
                {{
                  pog.comments.length > 0
                    ? `${pog.comments.length} ${
                        pog.comments.length === 1 ? "milestone" : "milestones"
                      } added `
                    : "Key Milestones"
                }}
              </h4>
              <v-btn
                flat
                @click="
                  main = false;
                  createComment = true;
                  $emit('toggle-close');
                "
                ><v-icon>add</v-icon>&nbsp; edit</v-btn
              >
              <!--      Photos-->
              <h4 class="font-weight-light text-uppercase">
                {{
                  pog.photos.length > 0
                    ? `${pog.photos.length} ${
                        pog.photos.length === 1 ? "photo" : "photos"
                      } added `
                    : "Photos"
                }}
              </h4>
              <v-btn
                flat
                @click="
                  main = false;
                  uploadPhoto = true;
                  $emit('toggle-close');
                "
                ><v-icon>add</v-icon>&nbsp; edit</v-btn
              >
            </v-card>
          </v-slide-x-reverse-transition>
        </v-flex>

        <v-flex sm12 md10>
          <v-slide-y-reverse-transition>
            <v-card
              class="form-pad card-pad card-layout-2"
              v-show="next[3]"
              flat
            >
              <!--      Description-->
              <v-textarea
                outline
                :label="descriptionLabel"
                :rules="[
                  (v) =>
                    (!!v && (v || '').length <= 1000) ||
                    'A description is required and it must not have more than 1000 characters',
                ]"
                v-model="pog.description"
                required
              >
              </v-textarea>
            </v-card>
          </v-slide-y-reverse-transition>
        </v-flex>
        <v-flex sm12 md2>
          <v-slide-x-reverse-transition>
            <v-card class="form-pad card-pad card-layout-2" flat hover>
              <div v-show="next[4]">
                <!--   Reset or submit-->
                <v-btn dark color="primary" @click="submit()">save</v-btn>
                <v-btn v-if="pog.created" dark color="red" @click="deletePog()"
                  >delete</v-btn
                >
                <v-btn
                  v-if="pog.created"
                  dark
                  color="secondary"
                  @click="transferPog()"
                  >transfer ownership</v-btn
                >
              </div>
            </v-card>
          </v-slide-x-reverse-transition>
        </v-flex>
      </v-layout>
    </div>

    <!--    Sub-form pages-->
    <!--    start time-->
    <div v-show="!main && startTimePicker">
      <time-pog :time-type="'start'" @change-date="changeStartDate"></time-pog>
    </div>

    <!--    Contact-->
    <div v-show="!main && changeContact">
      <contact-pog
        :input-contact="pog.contact"
        @update-contact="updateContact"
      ></contact-pog>
    </div>

    <!--    Edit/Create Comment (i.e. milestones)-->
    <div v-show="!main && createComment">
      <edit-comment-pog
        :comments="pog.comments"
        @delete-comment="deleteComment"
        @show-message="showMessage"
        @create-comment="pushComment"
        @close-comments="closeComments"
      ></edit-comment-pog>
    </div>

    <!--    Upload photo-->
    <div v-show="!main && uploadPhoto">
      <upload-photo-pog
        :accepted-file-types="['image/*']"
        :pog="pog"
        :key="photoReset"
        @show-message="showMessage"
        @done-photos="closePhotos"
        @add-photos="addPhotos"
      ></upload-photo-pog>
    </div>
  </v-form>
</template>

<script>
import TimePOG from "./TimePOG";
import ContactPOG from "./ContactPOG";
import EditCommentPOG from "@/components/pog/EditCommentPOG";
import UploadPhotoPOG from "@/components/pog/UploadPhotoPOG";

export default {
  name: "NewPOG",

  components: {
    "time-pog": TimePOG,
    "contact-pog": ContactPOG,
    "edit-comment-pog": EditCommentPOG,
    "upload-photo-pog": UploadPhotoPOG,
  },

  props: {
    inputPOG: Object,
    mapCoordinates: Object,
  },

  beforeMount() {
    if (Object.keys(this.inputPOG).length > 0) {
      this.pog = { ...this.inputPOG };

      // Support legacy public attribute
      if (this.pog.public === true) this.pog.perms = "public";
      else if (this.pog.perms === undefined) this.pog.perms = "auth";

      this.startDateValid = true;
      this.contactValid = true;
      setTimeout(() => {
        this.$emit("saving-needed", false);
        this.noWatcher = false;
      }, 200);
    }
  },

  mounted() {
    this.loadCards(0);
  },

  data() {
    return {
      noWatcher: true,
      photoReset: 1,
      next: [true, true, true, true, true],
      // Form page toggles
      main: true,
      startTimePicker: false,
      startDateValid: false,
      changeContact: false,
      contactValid: false,
      createComment: false,
      uploadPhoto: false,

      pog: {
        // Auto
        created: null,
        createdByUser: null,

        // User
        name: null,
        description: null,
        public: false,
        perms: "user",
        type: "Conservation",
        activity: [],
        responsible: "Public",
        size: null,
        sizeType: "Hectares",
        partners: [],
        contact: {
          email: null,
          phone: null,
          organization: null,
        },
        start: null,
        timeline: null,
        timelineType: "years",
        coordinates: {
          lat: null,
          lng: null,
        },
        comments: [],
        photos: [],
      },
      types: ["Restoration/Enhancement", "Conservation", "Awareness/Education"],
      activities: [
        "Fencing",
        "Planting",
        "Erosion Control",
        "Crossing",
        "Off-Stream Watering",
        "Grass Buffer",
        "Decreased Stocking Rate",
        "Rotational Grazing",
        "Cattle Exclusion",
        "Manure Management",
        "Wetland Enhancement",
      ],
      responsibleTypes: ["Public", "Private", "Indigenous"],
      sizeTypes: ["Hectares", "Acres", "Quarter Sections"],
      timelines: ["days", "weeks", "months", "years"],
      valid: true,

      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      select: null,
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,
    };
  },

  computed: {
    user() {
      return this.$store.state.settings.user;
    },
    descriptionLabel() {
      if (this.pog.description)
        return `Description: Remaining characters ${1000 -
          this.pog.description.length}`;
      else
        return "Description: Please include the land type in your description";
    },
  },

  methods: {
    loadCards(i) {
      if (i < this.next.length) {
        this.next[i] = true;
        i++;
        setTimeout(() => {
          this.loadCards(i);
        }, 200);
      }
    },
    showMessage(msg, color) {
      this.$emit("show-message", msg, color);
    },
    confirmPublic(previousValue) {
      this.$swal
        .fire({
          title: "Confirm",
          text:
            "Are you sure you would like this Project to be viewable by the public?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Keep it private",
          confirmButtonText: "Yes, I'm sure",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((response) => {
          if (!response.value) this.pog.perms = previousValue;
          else this.pog.public = true;
        });
    },

    reset() {
      this.$refs.form.reset();
      this.startDateValid = false;
      this.contactValid = false;
    },

    deletePog() {
      this.$swal
        .fire({
          title: "Confirm",
          text:
            "Are you sure you want to delete this Project? This action may not be reversed.",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Oops...keep it",
          confirmButtonText: "Yes, I'm sure",
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((response) => {
          if (response.value) {
            this.reset();
            this.$emit("delete-pog", this.pog.usertransaction);
          }
        });
    },

    async transferPog() {
      const { value: user } = await this.$swal.fire({
        title: "Transfer Project Ownership",
        text:
          "You will not have access to this Project after you transfer ownership.",
        input: "text",
        confirmButtonText: "Transfer",
        inputPlaceholder: "Enter a username",
        showCancelButton: true,
      });

      if (user) {
        this.$emit(
          "transfer-pog",
          this.pog.usertransaction,
          this.pog.createdByUser,
          user
        );
      }
    },

    validateChildren() {
      if (!this.startDateValid) {
        this.$emit("show-message", "A start date is required", "red");
        return false;
      }

      if (!this.contactValid) {
        this.$emit("show-message", "Contact information required", "red");
        return false;
      }

      if (!this.pog.coordinates.lat) {
        this.$emit(
          "show-message",
          "You must choose coordinates from the map",
          "red"
        );
        return false;
      }

      return true;
    },

    submit() {
      if (this.$refs.form.validate() && this.validateChildren()) {
        if (this.pog.created || this.pog.perms === "user") {
          this.$emit("submit-pog", this.pog);
          setTimeout(() => this.$emit("saving-needed", false), 200);
        } else {
          this.$swal
            .fire({
              title: "Permission",
              text:
                "Do you have permission from the landowner to create this Project?",
              icon: "warning",
              showCancelButton: true,
              cancelButtonText: "No",
              confirmButtonText: "I do",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then((response) => {
              if (response.value) this.$emit("submit-pog", this.pog);
            });
        }
      }
    },

    changeStartDate(date) {
      if (date) {
        this.pog.start = date;
        this.startDateValid = true;
      }
      this.startTimePicker = false;
      this.main = true;
      this.$emit("toggle-close");
    },

    updateContact(contact) {
      if (contact) {
        this.pog.contact.name = contact.name;
        this.pog.contact.email = contact.email;
        this.pog.contact.phone = contact.phone;
        this.pog.contact.organization = contact.organization;
        this.contactValid = true;
      }
      this.changeContact = false;
      this.main = true;
      this.$emit("toggle-close");
    },

    closeComments() {
      this.createComment = false;
      this.main = true;
      this.$emit("toggle-close");
    },

    pushComment(comment, index) {
      if (index) {
        this.pog.comments[index] = comment;
      } else {
        this.pog.comments.push(comment);
      }
    },

    deleteComment(index) {
      let i = -1;
      this.pog.comments = this.pog.comments.filter(() => {
        i++;
        return i !== index;
      });
    },

    addPhotos(photos) {
      this.pog.photos = photos;
    },

    closePhotos() {
      this.main = true;
      this.uploadPhoto = false;
      this.$emit("toggle-close");
    },

    collectLocation() {
      this.$emit("activate-map-click");
    },
  },

  watch: {
    mapCoordinates: {
      handler: function(newCoords) {
        this.pog.coordinates.lat = newCoords.lat;
        this.pog.coordinates.lng = newCoords.lng;
      },
      deep: true,
    },
    "pog.perms": {
      handler: function(newVal, oldVal) {
        if (newVal === "public" && !this.noWatcher) {
          this.confirmPublic(oldVal);
        } else this.pog.public = false;
      },
      deep: true,
    },
    pog: {
      handler: function() {
        this.$emit("saving-needed", true);
      },
      deep: true,
    },
  },
};
</script>

<style>
.form-pad {
  padding: 15px;
}
.container-layout {
  min-height: 500px;
}
.add-pog-layout {
  max-height: 600px;
  overflow-y: auto;
}
.card-pad {
  margin: 10px;
}
.card-layout {
  background: linear-gradient(
    135deg,
    rgba(253, 153, 28, 0.3),
    rgba(32, 178, 245, 0.3)
  );
  min-height: 340px;
}
.card-layout-2 {
  background: linear-gradient(
    135deg,
    rgba(253, 153, 28, 0.3),
    rgba(32, 178, 245, 0.3)
  );
  min-height: 190px;
}
.timeline-center {
  position: absolute;
  bottom: 0;
}
</style>
